import React from 'react';
import ProtectedRoute from './protected';
import BranchPage from '../pages/branch-management';
import ViewBranchPage from '../pages/branch-management/view-branch';

export const BranchesRoutes = [
  <ProtectedRoute exact path='/branch' component={BranchPage} />,
  <ProtectedRoute exact path='/branch/view/:id' component={ViewBranchPage} />,
];